import React, { FunctionComponent } from "react";
import styles from "./Event.module.scss";
import EventProps from "./EventProps.interface";
import Anchor from "components/Anchor/Anchor";
import getImageAspectRatio from "app/media/helpers/getImageAspectRatio";
import ImageViewer from "components/ImageViewer/ImageViewer";
import getRelativeUrl from "helpers/getRelativeUrl";
import getImageCrop from "app/media/helpers/getImageCrop";
import Moment from "react-moment";

const Event: FunctionComponent<EventProps> = (props) => {
    const imageCrop = getImageCrop(props.image?.umbracoFile.crops, undefined, "Fullscreen (4:3)");
    const imageAspectRatio = getImageAspectRatio(imageCrop, props.image?.umbracoWidth, props.image?.umbracoHeight);

    return (
        <Anchor className={styles.wrapper} to={getRelativeUrl(props._url)}>
            <article className={styles.inner}>
                <div className={styles.media}>
                    {props.image ? (
                        <ImageViewer className={styles.image} src={props.image.umbracoFile.src} focalPoint={props.image.umbracoFile.focalPoint} aspectRatioX={imageAspectRatio.aspectRatioX} aspectRatioY={imageAspectRatio.aspectRatioY} />
                    ) : null}
                </div>

                <div className={styles.content}>
                    {props.eventDateStart && props.eventDateEnd ? (
                        <p className={styles.date}>
                            <Moment parse="YYYY-MM-DDTHH:mm:ss" format="DD. MMM">{props.eventDateStart}</Moment>
                            <span>&nbsp;</span>
                            <Moment parse="YYYY-MM-DDTHH:mm:ss" format="HH:mm">{props.eventDateStart}</Moment>
                            <span>&nbsp;-&nbsp;</span>
                            <Moment parse="YYYY-MM-DDTHH:mm:ss" format="HH:mm">{props.eventDateEnd}</Moment>
                        </p>
                    ) : null}

                    {props.eventTitle ? (
                        <h1 className={styles.headline}>{props.eventTitle}</h1>
                    ) : null}

                    {props.eventDescription ? (
                        <p className={styles.text}>{props.eventDescription}</p>
                    ) : null}

                </div>
            </article>
        </Anchor>
    );
};

export default Event;